const ValorantRegionModel = {
  NA: {
    id: 1,
    title: 'NA',
  },
  EU: {
    id: 2,
    title: 'EU',
  },
  LATIN_AMERICA_NORTH: {
    id: 3,
    title: 'Latin America North',
  },
  LATIN_AMERICA_SOUTH: {
    id: 4,
    title: 'Latin America South',
  },
  BRAZIL: {
    id: 5,
    title: 'Brazil',
  },
  SOUTH_KOREA: {
    id: 6,
    title: 'South Korea',
  },
  RUSSIA: {
    id: 7,
    title: 'Russia',
  },
  OCEANIA: {
    id: 8,
    title: 'Oceania',
  },
  JAPAN: {
    id: 9,
    title: 'Japan',
  },
  SOUTH_ASIA: {
    id: 10,
    title: 'South Asia',
  },
  MENA: {
    id: 11,
    title: 'MENA',
  },
  SEA: {
    id: 12,
    title: 'SEA',
  },
};

ValorantRegionModel.LIST = [
  ValorantRegionModel.NA,
  ValorantRegionModel.EU,
  ValorantRegionModel.LATIN_AMERICA_NORTH,
  ValorantRegionModel.LATIN_AMERICA_SOUTH,
  ValorantRegionModel.BRAZIL,
  ValorantRegionModel.SOUTH_KOREA,
  ValorantRegionModel.RUSSIA,
  ValorantRegionModel.OCEANIA,
  ValorantRegionModel.JAPAN,
  ValorantRegionModel.SOUTH_ASIA,
  ValorantRegionModel.MENA,
  ValorantRegionModel.SEA,
];

ValorantRegionModel.ID_TO_DATA = {
  [ValorantRegionModel.NA.id]: ValorantRegionModel.NA,
  [ValorantRegionModel.EU.id]: ValorantRegionModel.EU,
  [ValorantRegionModel.LATIN_AMERICA_NORTH.id]: ValorantRegionModel.LATIN_AMERICA_NORTH,
  [ValorantRegionModel.LATIN_AMERICA_SOUTH.id]: ValorantRegionModel.LATIN_AMERICA_SOUTH,
  [ValorantRegionModel.BRAZIL.id]: ValorantRegionModel.BRAZIL,
  [ValorantRegionModel.SOUTH_KOREA.id]: ValorantRegionModel.SOUTH_KOREA,
  [ValorantRegionModel.RUSSIA.id]: ValorantRegionModel.RUSSIA,
  [ValorantRegionModel.OCEANIA.id]: ValorantRegionModel.OCEANIA,
  [ValorantRegionModel.JAPAN.id]: ValorantRegionModel.JAPAN,
  [ValorantRegionModel.SOUTH_ASIA.id]: ValorantRegionModel.SOUTH_ASIA,
  [ValorantRegionModel.MENA.id]: ValorantRegionModel.MENA,
  [ValorantRegionModel.SEA.id]: ValorantRegionModel.SEA,
};

// eslint-disable-next-line import/prefer-default-export
export { ValorantRegionModel };
